import { useEffect, useState } from 'react';
import useMaps from '../hooks/useMaps';
import { MapView } from './MapView';
import { MapType } from '../CommonTypes';
import { Tooltip } from 'react-tooltip';
import TooltipMap from './TooltipMap';
import { showMapsViewAtom } from '../states/planner';
import { useAtom } from 'jotai';

export const MapViewer = ({ showAllTime }: { showAllTime?: boolean }) => {
  const [currentMap, setCurrentMap] = useState<MapType | null>(null);
  const [showMapsView, setShowMapsView] = useAtom(showMapsViewAtom);

  const [maps] = useMaps();

  useEffect(() => {
    if (maps && maps.length > 0) {
      setCurrentMap(maps[0]);
      if (showAllTime) {
        setShowMapsView(true);
      }
    }
  }, [maps, showAllTime, setShowMapsView]);

  return showMapsView && currentMap ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-2">
      {!showAllTime && (
        <div
          tabIndex={0}
          role="button"
          className="absolute inset-0 cursor-default bg-black/90"
          onClick={() => setShowMapsView(false)}
        />
      )}
      <div className="relative w-full max-w-7xl overflow-hidden rounded-lg bg-black md:rounded-lg">
        <MapView map={currentMap} setCurrentMap={setCurrentMap} />

        <Tooltip
          className="tooltipmedia"
          id={'map-tooltip'}
          render={TooltipMap}
          closeEvents={{ click: true, mouseleave: true, blur: true }}
          opacity={0.95}
          style={{
            backgroundColor: 'white',
            color: 'black',
            padding: '0px',
            borderRadius: '8px',
            zIndex: 10,
          }}
        />
        <div className="absolute left-0 top-20 z-50 flex -translate-y-1/2 flex-col gap-2">
          {maps.map((map, index) => (
            <button
              key={`map-button-${index}`}
              onClick={() => setCurrentMap(map)}
              className="rounded-r-md bg-black bg-opacity-50 px-2 py-1 text-xs text-white transition hover:scale-105 md:px-4 md:py-2 md:text-sm"
            >
              {map.name ?? `Scen ${index + 1}`}
            </button>
          ))}
        </div>
        {!showAllTime ? (
          <button
            onClick={() => setShowMapsView(false)}
            className="absolute left-1/2 top-3 -translate-x-1/2 rounded bg-black/50 px-3 py-1 text-white hover:bg-black/75 md:top-4 md:px-4 md:py-2"
          >
            ✕
          </button>
        ) : null}
      </div>
    </div>
  ) : null;
};
